<template>
    <div>
        <!-- 悠家民宿房源 -->
        <div class="channel_list">
            <div class="channel_list_title">
                <div class="title_img">
                    <img src="../../image/youjia.png"/>
                </div>
                <div class="title_house_name">悠家民宿</div>
                <div class="title_nav">房态管理|房价管理|订单管理</div>
                <div class="time">上线时间：{{ hourseInfo.dOnlineTime || "暂无" }}</div>
            </div>
            <div class="house_message" v-if="hourseInfo.houseInfoSon">
                <div class="house_img">
                    <img :src="hourseInfo.houseInfoSon.vCoverPic"/>
                </div>
                <div class="house_name">
                    {{ hourseInfo.vHousTitle }}
                </div>
                <div class="house_money">
                    <div class="house_money_list">
                        平日价：￥{{ hourseInfo.houseFavour.mDailyPrice }}/晚
                    </div>
                    <div class="house_money_list">
                        周末价：￥{{ hourseInfo.houseFavour.mWeekEndPrice }}/晚
                    </div>
                    <div class="house_money_list">
                        节日价：￥{{ hourseInfo.houseFavour.mFestivePrice }}/晚
                    </div>
                </div>
            </div>
            <div class="house_operation">
                <div class="house_status" v-if="hourseInfo.iHourseStatus == 0">
                    已下架
                </div>
                <div class="house_status" v-if="hourseInfo.iHourseStatus == 1">
                    待上线
                </div>
                <div class="house_status" v-if="hourseInfo.iHourseStatus == 2">
                    已上线
                </div>
                <div class="house_status" v-if="hourseInfo.iHourseStatus == 3">
                    待审核
                </div>
                <div class="house_status" v-if="hourseInfo.iHourseStatus == 4">
                    审核失败
                </div>
                <div class="house_btn">
                    <el-button
                        v-if="hourseInfo.iHourseStatus == 2"
                        type="primary"
                        class="soldOut"
                        @click="offShelfPut(0)"
                    >下架
                    </el-button
                    >
                    <el-button
                        v-if="hourseInfo.iHourseStatus == 0"
                        type="primary"
                        class="soldOut"
                        @click="offShelfPut(2)"
                    >重新上架
                    </el-button
                    >
                    <!-- <el-button type="primary" class="compile">编辑</el-button> -->
                    <el-button type="primary" class="delete" @click="deleteBtn"
                    >删除
                    </el-button
                    >
                </div>
            </div>
        </div>
        <!-- 途家渠道 -->
        <div class="approach_List">
            <div class="channel_list_title">
                <div class="title_img">
                    <img src="../../image/tj.png"/>
                </div>
                <div class="title_house_name">途家民宿</div>
                <div class="title_nav">房态管理|房价管理|订单管理</div>
                <div
                    class="time"
                    v-if="
            houseChannelInfoTJ.iChannelState !== 3 &&
              houseChannelInfoTJ.iChannelState !== null
          "
                >
                    绑定时间：{{ houseChannelInfoTJ.dUpdateTime || "暂无" }}
                </div>
            </div>
            <div class="approach_message">
                <div
                    class="link"
                    v-if="
            houseChannelInfoTJ.iChannelState !== 3 &&
              houseChannelInfoTJ.iChannelState !== null
          "
                >
                    链接：{{ houseChannelInfoTJ.vChannelUrl || "" }}
                </div>
                <div
                    class="approach_money"
                    v-if="
            houseChannelInfoTJ.iChannelState !== 3 &&
              houseChannelInfoTJ.iChannelState !== null
          "
                >
                    <div class="approach_money_list">
                        平日价：￥{{ houseChannelInfoTJ.mDailyChannel || "" }}/晚
                    </div>
                    <div class="approach_money_list">
                        周末价：￥{{ houseChannelInfoTJ.mWeekEndChannel || "" }}/晚
                    </div>
                    <div class="approach_money_list">
                        节日价：￥{{ houseChannelInfoTJ.mFestiveChannel || "" }}/晚
                    </div>
                </div>
                <div class="pigExamine" style="position: absolute;right: 2%;"
                     v-if="houseChannelInfoTJ.iChannelState !== 3 &&houseChannelInfoTJ.iChannelState !== null">
                    <el-button type="text" @click="alertTjExamine">
                        <span v-if="tjAuditInfo.auditStatus==1">待审核</span>
                        <span v-if="tjAuditInfo.auditStatus==2">审核通过</span>
                        <span v-if="tjAuditInfo.auditStatus==3">审核驳回</span>

                    </el-button>
                    <span style="margin-left: 30px;color: #f6b439"  v-if="tjAuditInfo.auditStatus">{{'途家房源Id:'+tjAuditInfo.tujiaId}}</span>
                </div>
            </div>
            <div class="approach_operation">
                <div
                    class="approach_number"
                    v-if="
            houseChannelInfoTJ.iChannelState !== 3 &&
              houseChannelInfoTJ.iChannelState !== null
          "
                >
                    账号：{{ houseChannelInfoTJ.vChannelAccount || "暂无" }}
                </div>
                <div class="approach_btn">
                    <el-button
                        v-if="houseChannelInfoTJ.iChannelState == 1"
                        type="primary"
                        class="soldOut"
                        @click="ChannelFromTheShelvesBtn(2)"
                    >下架
                    </el-button
                    >
                    <el-button
                        v-if="houseChannelInfoTJ.iChannelState == 2"
                        type="primary"
                        class="soldOut"
                        @click="putawayBtn(2)"
                    >重新上架
                    </el-button
                    >
                    <el-button
                        type="primary"
                        v-if="
              houseChannelInfoTJ.iChannelState !== 3 &&
                houseChannelInfoTJ.iChannelState !== null
            "
                        class="compile"
                        @click="UnlinkBtn(2)"
                    >解除绑定
                    </el-button
                    >
                    <el-button
                        v-if="
              houseChannelInfoTJ.iChannelState == 3 ||
                houseChannelInfoTJ.iChannelState == null
            "
                        type="primary"
                        class="compile"
                        @click="binding(2)"
                    >绑定门店
                    </el-button
                    >
                </div>
            </div>
        </div>
        <!-- 小猪渠道 -->
        <div class="approach_List">
            <div class="channel_list_title">
                <div class="title_img">
                    <img src="../../image/pig.png"/>
                </div>
                <div class="title_house_name">小猪民宿</div>
                <div class="title_nav">房态管理|房价管理|订单管理</div>
                <div
                    class="time"
                    v-if="
            houseChannelInfoXZ.iChannelState !== 3 &&
              houseChannelInfoXZ.iChannelState !== null
          "
                >
                    绑定时间：{{ houseChannelInfoXZ.dUpdateTime || "暂无" }}
                </div>
            </div>
            <div class="approach_message">
                <div
                    class="link"
                    v-if="
            houseChannelInfoXZ.iChannelState !== 3 &&
              houseChannelInfoXZ.iChannelState !== null
          "
                >
                    链接：{{ houseChannelInfoXZ.vChannelUrl || "" }}
                </div>
                <div
                    class="approach_money"
                    v-if="
            houseChannelInfoXZ.iChannelState !== 3 &&
              houseChannelInfoXZ.iChannelState !== null
          "
                >
                    <div class="approach_money_list">
                        平日价：￥{{ houseChannelInfoXZ.mDailyChannel || "" }}/晚
                    </div>
                    <div class="approach_money_list">
                        周末价：￥{{ houseChannelInfoXZ.mWeekEndChannel || "" }}/晚
                    </div>
                    <div class="approach_money_list">
                        节日价：￥{{ houseChannelInfoXZ.mFestiveChannel || "" }}/晚
                    </div>
                </div>
                <div class="pigExamine" style="position: absolute;right: 2%;"
                     v-if="houseChannelInfoXZ.iChannelState !== 3 &&houseChannelInfoXZ.iChannelState !== null">
                    <el-button type="text" @click="alertExamine">{{pigCheckMap[pigExamineInfo.checkStatus]||'审核中'}}</el-button>
                    <span style="margin-left: 30px;color: #f6b439"  v-if="pigExamineInfo.roomId">{{'小猪房源Id:'+pigExamineInfo.roomId}}</span>
                </div>
            </div>
            <div class="approach_operation">
                <div
                    class="approach_number"
                    v-if="
            houseChannelInfoXZ.iChannelState !== 3 &&
              houseChannelInfoXZ.iChannelState !== null
          "
                >
                    账号：{{ houseChannelInfoXZ.vChannelAccount || "暂无" }}
                </div>
                <div class="approach_btn">
                    <el-button
                        v-if="houseChannelInfoXZ.iChannelState == 1&&pigExamineInfo.checkStatus=='pushsuccess'"
                        type="primary"
                        class="soldOut"
                        @click="ChannelFromTheShelvesBtn(3)"
                    >下架
                    </el-button
                    >
                    <el-button
                        v-if="houseChannelInfoXZ.iChannelState == 2"
                        type="primary"
                        class="soldOut"
                        @click="putawayBtn(3)"
                    >重新上架
                    </el-button
                    >
                    <el-button
                        v-if="pigExamineInfo.checkStatus==='AuditReject'&&houseChannelInfoXZ.roomId"
                        type="primary"
                        class="soldOut"
                        @click="reCheckPig()"
                    >重新上架审核
                    </el-button
                    >
                    <el-button
                        type="primary"
                        v-if="
              houseChannelInfoXZ.iChannelState !== 3 &&
                houseChannelInfoXZ.iChannelState !== null
            "
                        class="compile"
                        @click="UnlinkBtn(3)"
                    >解除绑定
                    </el-button
                    >
                    <el-button
                        v-if="
              houseChannelInfoXZ.iChannelState == 3 ||
                houseChannelInfoXZ.iChannelState == null
            "
                        type="primary"
                        class="compile"
                        @click="binding(3)"
                    >同步房源到小猪
                    </el-button
                    >
                </div>
            </div>
        </div>
        <!-- 美团渠道 -->
        <div class="approach_List">
            <div class="channel_list_title">
                <div class="title_img">
                    <img src="../../image/mt.png"/>
                </div>
                <div class="title_house_name">美团民宿</div>
                <div class="title_nav">房态管理|房价管理|订单管理</div>
                <div
                    class="time"
                    v-if="
            houseChannelInfoMT.iChannelState !== 3 &&
              houseChannelInfoMT.iChannelState !== null
          "
                >
                    绑定时间：{{ houseChannelInfoMT.dUpdateTime || "暂无" }}
                </div>
            </div>
            <div class="approach_message">
                <div
                    class="link"
                    v-if="
            houseChannelInfoMT.iChannelState !== 3 &&
              houseChannelInfoMT.iChannelState !== null
          "
                >
                    链接：{{ houseChannelInfoMT.vChannelUrl || "" }}
                </div>
                <div
                    class="approach_money"
                    v-if="
            houseChannelInfoMT.iChannelState !== 3 &&
              houseChannelInfoMT.iChannelState !== null
          "
                >
                    <div class="approach_money_list">
                        平日价：￥{{ houseChannelInfoMT.mDailyChannel || "" }}/晚
                    </div>
                    <div class="approach_money_list">
                        周末价：￥{{ houseChannelInfoMT.mWeekEndChannel || "" }}/晚
                    </div>
                    <div class="approach_money_list">
                        节日价：￥{{ houseChannelInfoMT.mFestiveChannel || "" }}/晚
                    </div>
                </div>
            </div>
            <div class="approach_operation">
                <div
                    class="approach_number"
                    v-if="
            houseChannelInfoMT.iChannelState !== 3 &&
              houseChannelInfoMT.iChannelState !== null
          "
                >
                    账号：{{ houseChannelInfoMT.vChannelAccount || "暂无" }}
                </div>
                <div class="approach_btn">
                    <el-button
                        v-if="houseChannelInfoMT.iChannelState == 1"
                        type="primary"
                        class="soldOut"
                        @click="ChannelFromTheShelvesBtn(1)"
                    >下架
                    </el-button
                    >
                    <el-button
                        v-if="houseChannelInfoMT.iChannelState == 2"
                        type="primary"
                        class="soldOut"
                        @click="putawayBtn(1)"
                    >重新上架
                    </el-button
                    >
                    <el-button
                        type="primary"
                        v-if="
              houseChannelInfoMT.iChannelState !== 3 &&
                houseChannelInfoMT.iChannelState !== null
            "
                        class="compile"
                        @click="UnlinkBtn(1)"
                    >解除绑定
                    </el-button
                    >
                    <el-button
                        v-if="
              houseChannelInfoMT.iChannelState == 3 ||
                houseChannelInfoMT.iChannelState == null
            "
                        type="primary"
                        class="compile"
                        @click="binding(1)"
                    >绑定账号
                    </el-button
                    >
                </div>
            </div>
        </div>
        <!-- 爱彼迎渠道 -->
<!--        <div class="approach_List">-->
<!--            <div class="channel_list_title">-->
<!--                <div class="title_img">-->
<!--                    <img src="../../image/ai.png"/>-->
<!--                </div>-->
<!--                <div class="title_house_name">爱彼迎民宿</div>-->
<!--                <div class="title_nav">房态管理|房价管理|订单管理</div>-->
<!--                <div-->
<!--                    class="time"-->
<!--                    v-if="-->
<!--            houseChannelInfoAI.iChannelState !== 3 &&-->
<!--              houseChannelInfoAI.iChannelState !== null-->
<!--          "-->
<!--                >-->
<!--                    绑定时间：{{ houseChannelInfoAI.dUpdateTime || "暂无" }}-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="approach_message">-->
<!--                <div-->
<!--                    class="link"-->
<!--                    v-if="-->
<!--            houseChannelInfoAI.iChannelState !== 3 &&-->
<!--              houseChannelInfoAI.iChannelState !== null-->
<!--          "-->
<!--                >-->
<!--                    链接：{{ houseChannelInfoAI.vChannelUrl || "" }}-->
<!--                </div>-->
<!--                <div-->
<!--                    class="approach_money"-->
<!--                    v-if="-->
<!--            houseChannelInfoAI.iChannelState !== 3 &&-->
<!--              houseChannelInfoAI.iChannelState !== null-->
<!--          "-->
<!--                >-->
<!--                    <div class="approach_money_list">-->
<!--                        平日价：￥{{ houseChannelInfoAI.mDailyChannel || "" }}/晚-->
<!--                    </div>-->
<!--                    <div class="approach_money_list">-->
<!--                        周末价：￥{{ houseChannelInfoAI.mWeekEndChannel || "" }}/晚-->
<!--                    </div>-->
<!--                    <div class="approach_money_list">-->
<!--                        节日价：￥{{ houseChannelInfoAI.mFestiveChannel || "" }}/晚-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="approach_operation">-->
<!--                <div-->
<!--                    class="approach_number"-->
<!--                    v-if="-->
<!--            houseChannelInfoAI.iChannelState !== 3 &&-->
<!--              houseChannelInfoAI.iChannelState !== null-->
<!--          "-->
<!--                >-->
<!--                    账号：{{ houseChannelInfoAI.vChannelAccount || "暂无" }}-->
<!--                </div>-->
<!--                <div class="approach_btn">-->
<!--                    <el-button-->
<!--                        v-if="houseChannelInfoAI.iChannelState == 1"-->
<!--                        type="primary"-->
<!--                        class="soldOut"-->
<!--                        @click="ChannelFromTheShelvesBtn(4)"-->
<!--                    >下架-->
<!--                    </el-button-->
<!--                    >-->
<!--                    <el-button-->
<!--                        v-if="houseChannelInfoAI.iChannelState == 2"-->
<!--                        type="primary"-->
<!--                        class="soldOut"-->
<!--                        @click="putawayBtn(4)"-->
<!--                    >重新上架-->
<!--                    </el-button-->
<!--                    >-->
<!--                    <el-button-->
<!--                        type="primary"-->
<!--                        v-if="-->
<!--              houseChannelInfoAI.iChannelState !== 3 &&-->
<!--                houseChannelInfoAI.iChannelState !== null-->
<!--            "-->
<!--                        class="compile"-->
<!--                        @click="UnlinkBtn(4)"-->
<!--                    >解除绑定-->
<!--                    </el-button-->
<!--                    >-->
<!--                    <el-button-->
<!--                        v-if="-->
<!--              houseChannelInfoAI.iChannelState == 3 ||-->
<!--                houseChannelInfoAI.iChannelState == null-->
<!--            "-->
<!--                        type="primary"-->
<!--                        class="compile"-->
<!--                        @click="binding(4)"-->
<!--                    >绑定账号-->
<!--                    </el-button-->
<!--                    >-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <!-- 新建渠道关联弹窗 -->
        <el-dialog
            title="账号绑定"
            :visible.sync="dialogVisible"
            width="720px"
            :before-close="handleClose"
       >
            <el-form ref="form" :model="form" label-width="80px">
<!--                <el-form-item label="链接：" v-if='this.form.iChannelId!=3'>
                    <el-input
                        v-model="form.vChannelUrl"
                        placeholder="房源链接"
                    ></el-input>
                </el-form-item>-->
                <div class="price_box">
                    <div class="price">
                        <span> 平时价：</span> <input v-model="form.mDailyChannel"/><span
                    >/晚</span
                    >
                    </div>
                    <div class="price">
                        <span> 周末价：</span> <input v-model="form.mWeekEndChannel"/><span
                    >/晚</span
                    >
                    </div>
                    <div class="price">
                        <span> 节日价：</span> <input v-model="form.mFestiveChannel"/><span
                    >/晚</span
                    >
                    </div>
                </div>
<!--                <el-form-item label="账号：" v-if='this.form.iChannelId!=3'>
                    <el-input
                        v-model="form.vChannelAccount"
                        placeholder="您的注册手机号"
                    ></el-input>
                </el-form-item>-->
                <el-form-item class="radioBox" style="width: 100%;display: flex">

                        <div class="item">
                            <el-radio v-model="form.iChannelState" label="1">已上线</el-radio>
                            <el-radio v-model="form.iChannelState" label="2">下架</el-radio>
                        </div>
                        <div v-if="form.iChannelId===2" class="item" style="margin-left: 50px">
                            <span>是否开启闪定&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <el-radio v-model="form.isInstantConfirm" :label="true">是</el-radio>
                            <el-radio v-model="form.isInstantConfirm" :label="false">否</el-radio>

                        </div>
                    <span  v-if="form.iChannelId===2" style="font-size: 16px;color: #fc0a0a">
                        *只有开启闪定才能自动接单,否则需要手动接单
                    </span>

                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" class="cancel"
        >取 消</el-button
        >
        <el-button type="primary" @click="add_new_btn" class="add_new_btn"
        >确 定</el-button
        >
      </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    DeleteHourse,
    houseChannel,
    houseChannelChange,
    houseChannelInfo,
    offShelf,
    oneGhost, pigOnlineHousing, pigUnitOnline, shelfDown,
    syncMtProduct, addTjHousing, selectExamine, gcj02ToBd09ll, queryHouseInfo, unitstatus
} from "../../api/index";
export default {
    data() {
        return {
            houseChannelInfoTJ: [],
            houseChannelInfoMT: [],
            houseChannelInfoAI: [],
            houseChannelInfoXZ: [],
            hourseInfo: [],
            houseId: "",
            pigHousing:null,//小猪上架回调
            dialogVisible: false,
            form: {
                houseId: "",
                iChannelId: "",
                vChannelUrl: "",
                mDailyChannel: "",
                mWeekEndChannel: "",
                mFestiveChannel: "",
                vChannelAccount: "",
                iChannelState: "1",
                isInstantConfirm:true,// 是否开启闪定
            },
            offShelfInfo: {
                houseId: "",
                iHourseStatus: 1
            },
            // 渠道下架
            ChannelFromTheShelves: {
                houseId: "",
                iChannelId: "",
                iChannelState: "2"
            },
            // 渠道上架
            putaway: {
                houseId: "",
                iChannelId: "",
                iChannelState: "1"
            },
            // 渠道解绑
            Unlink: {
                houseId: "",
                iChannelId: "",
                iChannelState: "3"
            },
        //    小猪审核信息
            pigExamineInfo:{
                searchValue: null,
                createBy: null,
                createTime: null,
                del: false,
                updateBy: null,
                updateTime: null,
                remark: null,
                params: {},
                houseId: "",
                roomId: null,
                addressId: "",
                landlordId: "",
                state: null,
                checkStatus: null,
                rejectReason: null
            },
            pigCheckMap:{
                'AuditIng':'审核中',
                'AuditReject':'审核拒绝',
                'AuditPass':'审核通过',
                'pushsuccess':'发布通过',
                'pushfail':'发布未通过'
            },
            tjAuditInfo:{}
        };
    },
    created() {
        this.houseId = sessionStorage.getItem("houseId");
        this.form.houseId = sessionStorage.getItem("houseId");
        this.offShelfInfo.houseId = sessionStorage.getItem("houseId");
        this.ChannelFromTheShelves.houseId = this.putaway.houseId = this.Unlink.houseId = sessionStorage.getItem(
            "houseId"
        );
        this.getPigExamine();
        this.houseChannelInfoGet();
        this.queryTJHouseInfo();
        // this.hourseAuditListGet();
    },
    methods: {
        add_new_btn() {
            this.houseChannelPost();
        },
        binding(e) {
            this.form.iChannelId = e;
            this.dialogVisible = true;
        },
        // 悠家下架
        offShelfPut(e) {
            let status = e == 2 ? "上架" : "下架";
            this.offShelfInfo.iHourseStatus = e;
            this.$confirm("是否确认" + status + "该房源？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(async () => {
                    const {data: res} = await offShelf(this.offShelfInfo);
                    if (res.code !== 200)
                        return this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    this.houseChannelInfoGet();
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        //查询途家审核状态
        queryTJHouseInfo(){
            queryHouseInfo({unitIds:this.houseId}).then(res=>{
                if(res.data.code==200){
                    this.tjAuditInfo = JSON.parse(res.data.data)[0];
                    console.log(this.tjAuditInfo)
                }
            })
        },
        // // 获取房源信息
        // async hourseAuditListGet() {
        //   try {
        //     const { data: res } = await hourseAuditList(this.houseId);
        //     if (res.code !== 200)
        //       return this.$message({
        //         message: res.msg,
        //         type: "error"
        //       });
        //     this.hourseInfo = res.data.hourseInfo || "";
        //   } catch (error) {
        //     console.log(error);
        //   }
        // },
        // 新建渠道列表
        async houseChannelPost() {
            console.log(this.form)
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            switch (this.form.iChannelId) {
                case 1:
                    const {data: res} = await  oneGhost({houseId: this.form.houseId});
                    loading.close();
                    if (res.code != 200) {
                        return this.$message.error(res.msg);
                    }

                    console.log('美团')
                    break;
                case 2:

                    let params = {
                        acceptBreachUser:0,//是否接待失信客户，
                        active:this.form.iChannelState==1?1:0,//是否上线
                        address:this.hourseInfo.address,//门店地址
                        cancelWithoutDuty:1,//是否支持30min无责取消 0：否 1：是
                        coordinateType:'gcj02',//经纬度类型:wgs84,gcj02, bd09ll
                        email:'252307491@qq.com',//	联系邮件
                        hasFrontDesk:1,//	是否有前台 0：否 1：是
                        instruction:this.hourseInfo.vHousTitle,//门店简介
                        is_instant_confirm:this.form.isInstantConfirm,//	是否开启闪订 0.否 1.是
                        is_oversea:0,//	是否海外门店0.否 1.是
                        is_support_im:0, //是否支持IM
                        latitude:this.hourseInfo.latitude, //纬度
                        logo:this.hourseInfo.houseInfoSon.vCoverPic,//门店logo
                        longtitude:this.hourseInfo.longtitude,//经度
                        name:this.hourseInfo.vHousTitle, //门店名称
                        need_translation:0, //	房源信息是否需要翻译（统一传false）
                        tel:this.hourseInfo?.customer?.phonenumber||'18907127778', //门店电话
                        operationTel:this.hourseInfo?.customer?.phonenumber||'18907127778', //运营电话
                        partner_hid:this.hourseInfo.houseId

                    }
                    console.log(params,this.hourseInfo.customer)

                    const {data: result} = await  addTjHousing(params);
                    loading.close();
                    if (result.code != 200) {
                        return this.$message.error(result.msg);
                    }

                    console.log('途家===>',result)
                    break;
                case 3:
                    const {data: re}  = await this.pigOnlineHousing();
                    loading.close();
                    if (re.code != 200) {
                        return this.$message.error(re.msg);
                    }

                    //上线
                    //  this.pigUnitOnline(1)
                    console.log('小猪')
                    break;
            }

            const {data: res} = await houseChannel(this.form);
            if (res.code !== 200)
                return this.$message({
                    message: res.msg,
                    type: "error"
                });


            this.form = {
                houseId: sessionStorage.getItem("houseId"),
                iChannelId: "",
                vChannelUrl: "",
                mDailyChannel: "",
                mWeekEndChannel: "",
                mFestiveChannel: "",
                vChannelAccount: "",
                iChannelState: "1"
            };
            this.dialogVisible = false;
            loading.close();
            this.houseChannelInfoGet();
        },
        // 查询房源渠道列表
        async houseChannelInfoGet() {
            const {data: res} = await houseChannelInfo({houseId: this.houseId});
            this.hourseInfo = res.data.hourseInfo || "";
            this.houseChannelInfoTJ = res.data.tujia || [];
            this.houseChannelInfoMT = res.data.meituan || [];
            this.houseChannelInfoAI = res.data.aibiyin || [];
            this.houseChannelInfoXZ = res.data.xiaoPig || [];
            this.pigHousing=res.data.pigHousing||null;
            console.log('1111111111',res.data)
            if(this.pigHousing&&this.pigHousing.roomId&&!this.pigHousing.rejectReason){
                //上线
                let re = await this.pigUnitOnline(1)
                /*if (re.code !== 200)
                    return this.$message.error(re.msg);*/
            }

        },
        // 渠道下架房源
        ChannelFromTheShelvesBtn(e) {
            this.ChannelFromTheShelves.iChannelId = e;
            this.$confirm("此操作将下架该房源, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(async () => {
                    console.log(this.pigHousing)
                    //下架小猪房源
                    if (e == '3'&&this.pigHousing&&this.pigHousing.roomId) {
                        let re = await this.pigUnitOnline(0)
                        if (re.code !== 200)
                            return this.$message.error(re.msg);
                    } else if (e == '1') {
                        //下架美团房源
                        console.log(this.$route/*.params.productId*/)
                        let re = await shelfDown({
                            productId: this.houseChannelInfoMT.productId,
                            reason: '平台手动下架房源'
                        })

                        if (re.data.code !== 200)
                            return this.$message.error(re.data.msg);
                    } else if (e == '2'){

                        let re = await unitstatus({
                            status:[ {'partner_uid':this.houseId,active: false}]
                        })
                        console.log(re)
                        if (re.data.code !== 200)
                            return this.$message.error(re.data.msg);
                    }

                    const {data: res} = await houseChannelChange(
                        this.ChannelFromTheShelves
                    );

                    if (res.code !== 200)
                        return this.$message({
                            type: "error",
                            message: res.msg
                        });


                     this.houseChannelInfoGet();

                })
                .catch((error) => {
                    console.log(error)
                    this.$message({
                        type: "info",
                        message: "已取消下架"
                    });
                });
        },
        //上架小猪房源
        async pigOnlineHousing() {
            const re = await pigOnlineHousing({
                housingId: this.form.houseId,
                id: sessionStorage.getItem('customerId')
            });
            return re;
        },
        // 重新审核小猪
        async reCheckPig(){
            const re = await pigOnlineHousing({
                housingId: this.form.houseId,
                id: sessionStorage.getItem('customerId'),
                type:!this.pigHousing.roomId&&this.pigExamineInfo.checkStatus==='AuditReject'?0:null
            });
            // pigExamineInfo.checkStatus AuditReject 没有小猪房源id且审核拒绝传type
            this.houseChannelInfoGet();
        },
        //上线Or下线小猪房源
        async pigUnitOnline(state) {
            const {data: re} = await pigUnitOnline({
                housingId: this.form.houseId,
                id: sessionStorage.getItem('customerId'),
                state: state
            });
            return re;
        },

        // 渠道上架房源
        putawayBtn(e) {
            this.putaway.iChannelId = e;
            this.$confirm("此操作将重新上架该房源, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(async () => {
                    const {data: res} = await houseChannelChange(this.putaway);
                    if (res.code !== 200)
                        return this.$message({
                            type: "error",
                            message: res.msg
                        });
                    if (e == 3) {
                        let re = await this.pigUnitOnline(1);
                        if (re.code != 200) {
                            return this.$message.error(re.msg);
                        }
                    }
                    if (e == 2) {
                        let re = await unitstatus({
                            status:[{'partner_uid':this.houseId,active:true}]
                        });
                        if (re.data.code != 200) {
                            return this.$message.error(re.data.msg);
                        }
                    }
                    this.houseChannelInfoGet();
                    return this.$message({
                        type: "success",
                        message: res.msg
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消上架"
                    });
                });
        },
        // 渠道解绑
        UnlinkBtn(e) {
            this.Unlink.iChannelId = e;
            this.$confirm("此操作将解除绑定该房源, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(async () => {
                    //下架小猪房源
                    if (e == '3'&&this.pigHousing&&this.pigHousing.roomId) {
                        let re = await this.pigUnitOnline(0)
                        if (re.code !== 200)
                            return this.$message.error(re.msg);
                    } else if (e == '1') {
                        //下架美团房源
                        console.log(this.$route/*.params.productId*/)
                        let re = await shelfDown({
                            productId: this.houseChannelInfoMT.productId,
                            reason: '平台手动下架房源'
                        })

                        if (re.data.code !== 200)
                            return this.$message.error(re.data.msg);
                    } else if (e == '2'){

                        let re = await unitstatus({
                            status:[ {'partner_uid':this.houseId,active: false}]
                        })
                        console.log(re)
                        if (re.data.code !== 200)
                            return this.$message.error(re.data.msg);
                    }
                    const {data: res} = await houseChannelChange(this.Unlink);
                    if (res.code !== 200)
                        return this.$message({
                            type: "error",
                            message: res.msg
                        });
                    this.houseChannelInfoGet();
                    return this.$message({
                        type: "success",
                        message: res.msg
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消解除绑定"
                    });
                });
        },
        // 删除房源
        deleteBtn() {
            this.$confirm("此操作将永久删除该房源, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(async () => {
                    const {data: res} = await DeleteHourse({houseId: this.houseId});
                    console.log(res.code);
                    if (res.code !== 200)
                        return this.$message({
                            type: "error",
                            message: res.msg
                        });

                    this.$router.push({
                        name: "managementList" //跳转的路径
                    });
                    this.houseChannelInfoGet();
                    return this.$message({
                        type: "success",
                        message: "删除成功!"
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        handleClose(done) {
            this.$confirm("确认关闭？")
                .then(_ => {
                    done();
                })
                .catch(_ => {
                });
        },
        alertTjExamine(){
            console.log(this.tjAuditInfo);
            let map = {'1':'待审核','2':'审核通过','3':'审核驳回'}
            let name =map[ this.tjAuditInfo.auditStatus]||'审核中';


            let temp = `<div>审核状态:  ${name}</div>`
            if(this.tjAuditInfo.auditStatus==3){
                temp+=`<div>拒绝原因:  ${this.tjAuditInfo.examine}</div>`
            }
            if(this.tjAuditInfo.auditStatus){
                temp+=`<div style="color: #f6b439;margin-top: 30px">途家房源Id:  ${this.tjAuditInfo.tujiaId}</div>`
            }
            this.$alert(temp, '审核结果', {
                dangerouslyUseHTMLString: true
            });

        },
        alertExamine(){
            console.log( this.pigCheckMap,this.pigExamineInfo)
            let name = this.pigCheckMap[this.pigExamineInfo.checkStatus]||'审核中';
            let rejectReason = this.pigExamineInfo.rejectReason||'审核中';
            if(this.pigExamineInfo.checkStatus=='pushsuccess'){
                rejectReason='发布通过'
            }
            if(this.pigExamineInfo.checkStatus=='AuditPass'){
                rejectReason='发布通过'
            }
            let arr = ['审核通过','发布通过','审核中']
            let temp = `<div>审核状态:  ${name}</div>`
                if(!arr.includes(rejectReason)){
                    temp+=`<div>拒绝原因:  ${rejectReason}</div>`
                }
            if(this.pigExamineInfo.roomId){
                temp+=`<div style="color: #f6b439;margin-top: 30px">小猪房源Id:  ${this.pigExamineInfo.roomId}</div>`
            }
            this.$alert(temp, '审核结果', {
                dangerouslyUseHTMLString: true
            });

        },
        getPigExamine(){
            selectExamine({houseId:this.houseId}).then(res=>{
                if(res&&res.data.code==200){

                    this.pigExamineInfo = res.data.data|| this.pigExamineInfo
                    /*if(new Date(this.houseChannelInfoXZ.dUpdateDate).getTime()>=){

                    }*/
                    console.log(this.pigExamineInfo)
                }
            })
        }
    }
};
</script>

<style lang="less" scoped>
.channel_list {
    padding: 15px;
    margin: 24px 0;
    width: 100%;
    height: 246px;
    border: 1px solid #e1e1e1;

    .channel_list_title {
        height: 55px;
        border-bottom: 1px solid #e1e1e1;

        .title_img {
            float: left;
            height: 40px;
            width: 40px;
            border-radius: 8px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .title_house_name {
            margin-top: 7px;
            float: left;
            margin-left: 20px;
            font-weight: bold;
            font-size: 20px;
            color: #171a1e;
        }

        .title_nav {
            margin-left: 10px;
            margin-top: 12px;
            float: left;
            color: #666666;
            font-size: 12px;
        }

        .time {
            float: right;
            font-size: 16px;
            color: #171a1e;
        }
    }

    .house_message {
        position: relative;
        height: 100px;
        padding: 20px 0;
        border-bottom: 1px solid #e1e1e1;

        .house_img {
            float: left;
            width: 96px;
            height: 60px;

            img {
                width: 96px;
                height: 60px;
            }
        }

        .house_name {
            float: left;
            font-weight: bold;
            font-size: 20px;
            width: 708px;
            margin-left: 15px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .house_money {
            position: absolute;
            top: 55px;
            left: 111px;
            height: 21px;

            .house_money_list {
                width: 160px;
                height: 21px;
                font-size: 16px;
                line-height: 21px;
                float: left;
            }
        }
    }

    .house_operation {
        margin-top: 20px;

        .house_status {
            margin-top: 7px;
            float: left;
            font-weight: bold;
            font-size: 16px;
        }
    }

    .house_btn {
        float: right;

        .soldOut {
            background-color: #ef6e2d;
            border: #ef6e2d;
            width: 96px;
            height: 36px;
            float: left;
            margin-right: 10px;
        }

        .compile {
            background-color: #2f80ed;
            border: #2f80ed;
            width: 96px;
            height: 36px;
            float: left;
            margin-right: 10px;
        }

        .delete {
            background-color: #eb5757;
            border: #eb5757;
            width: 96px;
            height: 36px;
            float: left;
        }
    }
}

/deep/ .el-button {
    padding: 0;
}

.approach_List {
    width: 100%;
    height: 233px;
    border: 1px solid #e1e1e1;
    margin-bottom: 24px;
    padding: 15px;

    .channel_list_title {
        height: 55px;
        border-bottom: 1px solid #e1e1e1;

        .title_img {
            float: left;
            height: 40px;
            width: 40px;
            border-radius: 8px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .title_house_name {
            margin-top: 7px;
            float: left;
            margin-left: 20px;
            font-weight: bold;
            font-size: 20px;
            color: #171a1e;
        }

        .title_nav {
            margin-left: 10px;
            margin-top: 12px;
            float: left;
            color: #666666;
            font-size: 12px;
        }

        .time {
            float: right;
            font-size: 16px;
            color: #171a1e;
        }
    }

    .approach_message {
        position: relative;
        padding: 15px 0;
        height: 87px;
        border-bottom: 1px solid #e1e1e1;

        .link {
            font-size: 16px;
            color: #000000;
        }

        .approach_money {
            top: 51px;
            left: 0px;
            height: 21px;
            position: absolute;

            .approach_money_list {
                width: 160px;
                height: 21px;
                font-size: 16px;
                line-height: 21px;
                float: left;
                color: #000000;
            }
        }
    }

    .approach_operation {
        .approach_number {
            margin-top: 27px;
            font-size: 16px;
            color: #000000;
            float: left;
        }

        .approach_btn {
            float: right;
            margin-top: 20px;

            .soldOut {
                background-color: #ef6e2d;
                border: #ef6e2d;
                width: 96px;
                height: 36px;
                float: left;
                margin-left: 20px;
            }

            .compile {
                background-color: #f6b439;
                border: #f6b439;
                width: 96px;
                height: 36px;
                float: left;
                margin-left: 20px;
            }
        }
    }
}

/deep/ .el-dialog__header {
    padding: 24px;
}

/deep/ .el-dialog__body {
    padding: 26px 58px 26px 48px;
}

/deep/ .el-dialog__footer {
    padding: 0px 58px 40px;
}

.price_box {
    padding-left: 10px;
    width: 100%;
    height: 36px;
    margin-bottom: 30px;
    display: flex;

    .price {
        flex: 1;

        input {
            margin: 0 10px;
            width: 72px;
            height: 36px;
            border: 1px solid #e1e1e1;
            box-sizing: border-box;
            border-radius: 6px;
        }
    }
}

/deep/ .el-radio__label {
    font-size: 16px;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #f6b439;
    background: #f6b439;
    width: 24px;
    height: 24px;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #f6b439;
}

/deep/ .el-radio__inner {
    width: 24px;
    height: 24px;
}

/deep/ .el-radio__inner::after {
    width: 10px;
    height: 10px;
}

.add_new_btn {
    width: 72px;
    height: 36px;
    background-color: #f6b439;
    border: 1px solid #f6b439;
}

.cancel {
    width: 72px;
    height: 36px;
    background: #f2f2f2;
    border: 1px solid #e1e1e1;
}
.radioBox /deep/ .el-form-item__content{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}
</style>
